import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IntegrationStatuses = {
  ACTIVE: 'ACTIVE',
  INITIALIZING: 'INITIALIZING',
  DISCONNECTED: 'DISCONNECTED',
  DELETED: 'DELETED',
  DISABLED: 'DISABLED',
} as const

export type IntegrationStatusEnum = Enum<typeof IntegrationStatuses>
